import baseAPI from '@/api/base';
import { EditEmployeeBank, GetEmployeeBank, RegisterEmployeeBank } from '@/dtos/employee_bank.dto';
import {
  DELETE_EMPLOYEE_BANK_URL,
  EDIT_EMPLOYEE_BANK_URL,
  GET_EMPLOYEE_BANK_URL,
  REGISTER_EMPLOYEE_BANK_URL,
  TOGGLE_EMPLOYEE_BANK_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class EmployeeBank {
  static getEmployeeBanks = async (getEmployeeBank: GetEmployeeBank): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_EMPLOYEE_BANK_URL, {
      params: getEmployeeBank,
    });
    console.log('response', response);
    return response;
  };

  static registerEmployeeBank = async (
    registerEmployeeBank: RegisterEmployeeBank
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_EMPLOYEE_BANK_URL, {
      ...registerEmployeeBank,
    });
    console.log('response', response);
    return response;
  };

  static editEmployeeBank = async (editEmployeeBank: EditEmployeeBank): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_EMPLOYEE_BANK_URL, {
      ...editEmployeeBank,
    });
    return response;
  };

  static toggleEmployeeBankIsActive = async (
    editEmployeeBank: EditEmployeeBank
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_EMPLOYEE_BANK_IS_ACTIVE_URL,
      {
        ...editEmployeeBank,
      }
    );
    return response;
  };

  static deleteEmployeeBank = async (userId: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_EMPLOYEE_BANK_URL}/${userId}`
    );
    return response;
  };
}

export default EmployeeBank;
